<label *ngIf="placeholderAsLabel" class="mb-1 d-inline-block" [ngStyle]="colorTextAlignStyle">{{
  placeholder
}}</label>

<div class="custom-dropdown-wrapper" (clickOutside)="closeDropdown()">
  <div
    #dropdownBoxRef
    hlmInput
    tabindex="0"
    [class]="class"
    class="custom-dropdown-box d-flex align-items-center is-space-between"
    [class.is-disabled]="isDisabled"
    [class.open]="isOpen"
    [ngStyle]="textCombinedStyle"
    (click)="toggleDropdown()"
    (blur)="onBoxBlur()"
  >
    <ng-container *ngIf="!selectedItemTemplate; else customSelectedItem">
      <ng-container
        *ngTemplateOutlet="defaultSelectedItemTemplate; context: { $implicit: selectedDisplayOption }"
      ></ng-container>
    </ng-container>
    <ng-template #customSelectedItem>
      <ng-container
        *ngTemplateOutlet="selectedItemTemplate; context: { $implicit: selectedDisplayOption }"
      ></ng-container>
    </ng-template>

    <span class="dropdown-arrow"></span>
  </div>

  @if (isOpen) {
  <div
    #dropdownPanelRef
    class="custom-dropdown-panel"
    [ngClass]="panelStyleClass"
    [ngStyle]="panelPositionStyle"
  >
    @if (filter) {
    <div class="search-container">
      <input
        type="text"
        class="inputField"
        placeholder="Search..."
        [value]="searchQuery"
        (click)="$event.stopPropagation()"
        (input)="onSearchInputChange($event)"
      />
    </div>
    }
    <div class="list-with-scroll">
      @for (option of filteredOptions; track option) {
      <div class="dropdown-option" (click)="selectOption(option)" [class.selected]="isSelected(option)">
        <ng-container *ngIf="!itemTemplate; else customItem">
          <ng-container
            *ngTemplateOutlet="defaultItemTemplate; context: { $implicit: option }"
          ></ng-container>
        </ng-container>
        <ng-template #customItem>
          <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: option }"></ng-container>
        </ng-template>
      </div>
      } @empty {
      <div class="no-options">No options available</div>
      }
    </div>
  </div>
  }

  <!-- Default templates in case user doesn't provide any -->
  <ng-template #defaultSelectedItemTemplate let-option>
    @if (showAccountsListWithFlag) { @if (option) {
    <div class="d-flex align-items-center gap-2">
      <div
        *ngIf="option.currencyFlag?.length"
        class="d-flex"
        [innerHTML]="option.currencyFlag | safeHtml"
      ></div>
      <div>{{ option.title }}</div>
    </div>
    } @else {
    <span class="placeholder">{{ placeholderAsLabel ? '' : placeholder ?? '' }}</span>
    } } @else { @if (option !== undefined && option !== null && option !== '') {
    <span>{{ getOptionLabel(option) }}</span>
    } @else {
    <span class="placeholder">{{ placeholderAsLabel ? '' : placeholder ?? '' }}</span>
    } }
  </ng-template>
  <ng-template #defaultItemTemplate let-option>
    @if (showAccountsListWithFlag) {
    <div class="d-flex align-items-center gap-2">
      <div
        *ngIf="option.currencyFlag?.length"
        class="d-flex"
        [innerHTML]="option.currencyFlag | safeHtml"
      ></div>
      <div>{{ option.title }}</div>
    </div>
    } @else {
    <span>{{ getOptionLabel(option) }}</span>
    }
  </ng-template>
</div>
